export const business = {
  name: 'AS Elite Gatherings',
  tagline: 'Every Gathering, Elevated',
  addressLines: [
    '2nd Floor, AS Elite',
    'No: 114G, Railway Station Road',
    'Marthandam, Tamil Nadu 629165',
  ],
  addressOneLine:
    '2nd Floor, AS Elite, No:114G, Railway Station Road, Marthandam, Tamil Nadu 629165',
  phone: '+91 63822 82058',
  phoneHref: 'tel:+916382282058',
  email: 'aselitegatherings@gmail.com',
  mapsQuery:
    'https://www.google.com/maps?q=AS+Elite,+Railway+Station+Road,+Marthandam,+Tamil+Nadu+629165&output=embed',
  mapsLink:
    'https://www.google.com/maps/search/?api=1&query=AS+Elite,+Railway+Station+Road,+Marthandam,+Tamil+Nadu+629165',
}

export const socials = {
  instagram: 'https://www.instagram.com/aselite_gatherings/',
  facebook: 'https://www.facebook.com/aselitegatherings213',
  youtube: 'https://www.youtube.com/@aselitegathering',
}

export const services = [
  {
    id: 'corporate-events',
    number: '01',
    name: 'Corporate Events',
    short: 'Conferences, seminars, dealer meets & annual days handled end to end.',
    description:
      "From boardroom conferences to full-scale annual days, we plan the logistics your brand's reputation rides on — venue, staging, AV, hospitality and run-of-show — so your team can focus on the room, not the rigging.",
    image: '/images/corporate/corporate1.webp',
    highlights: ['Conferences & seminars', 'Dealer & franchise meets', 'Annual day celebrations', 'Award ceremonies'],
  },
  {
    id: 'product-launch',
    number: '02',
    name: 'Product Launch',
    short: 'A first impression engineered to be remembered.',
    description:
      'A launch has one shot at a first impression. We design the reveal moment — lighting, staging, sound and sequencing — so your product walks into the room exactly the way you imagined it.',
    image: '/images/product/product1.webp',
    highlights: ['Reveal staging & lighting', 'Media & press setup', 'Brand-led decor', 'Guest experience design'],
  },
  {
    id: 'private-party',
    number: '03',
    name: 'Private Party',
    short: 'Birthdays, anniversaries & milestone celebrations, made personal.',
    description:
      'Birthdays, get-togethers, retirement parties, baby showers — the celebrations that are really about the people in the room. We handle the setup and details so you can actually enjoy the evening.',
    image: '/images/privategatherings/privategatherings1.webp',
    highlights: ['Themed decor & lighting', 'Catering coordination', 'Entertainment booking', 'Return gifts & favors'],
  },
  {
    id: 'wedding',
    number: '04',
    name: 'Wedding',
    short: 'From the muhurtham stage to the reception exit, one seamless story.',
    description:
      'Engagement, muhurtham, reception — every wedding function has its own mood, and we design each one deliberately while keeping the whole celebration feeling like a single, considered story.',
    image: '/images/weddings/wedding1.webp',
    highlights: ['Mandap & stage design', 'Floral & lighting design', 'Guest hospitality', 'Multi-function coordination'],
  },
  {
    id: 'stage-decoration',
    number: '05',
    name: 'Stage Decoration',
    short: 'Backdrops and centerpieces built to hold every camera in the room.',
    description:
      "The stage is where every photo happens. We build backdrops, floral walls, LED and fabric setups tailored to your event's palette — grand enough to anchor the room, precise enough to survive close-up.",
    image: '/images/decor/decor1.webp',
    highlights: ['Custom backdrops', 'Floral & fabric walls', 'LED & ambient lighting', 'Entrance & photo-booth setups'],
  },
  {
    id: 'cultural-award-shows',
    number: '06',
    name: 'Award & Cultural Shows',
    short: 'Talent showcases and award functions, produced with a proper run-of-show.',
    description:
      'Cultural programs, talent showcases and award nights need a tight run-of-show as much as they need decor. We manage stage, sound, sequencing and hosting cues so the show runs exactly on beat.',
    image: '/images/awards/award1.webp',
    highlights: ['Award night production', 'Cultural programs', 'Talent showcase staging', 'Anchoring & sequencing support'],
  },
]

export const process = [
  {
    step: '01',
    title: 'Consultation',
    text: 'We start with a conversation — your event, your guests, your budget and the feeling you want the room to have.',
  },
  {
    step: '02',
    title: 'Design',
    text: 'A concept comes together: stage, decor, lighting and flow, shaped around your date and venue.',
  },
  {
    step: '03',
    title: 'Execution',
    text: 'Our team builds, rehearses and runs the event on the day, coordinating every vendor on site.',
  },
  {
    step: '04',
    title: 'Celebration',
    text: 'You walk in as a guest at your own event. We handle the room; you handle the moment.',
  },
]

export const galleryCategories = [
  'All',
  'Wedding',
  'Corporate',
  'Private Party',
  'Stage Decoration',
  'Product Launch',
  'Award',
]

export const galleryItems = [
  { id: 1, category: 'Wedding', image: '/images/weddings/wedding3.webp', title: 'Mandap Florals' },
  { id: 2, category: 'Stage Decoration', image: '/images/decor/decor4.webp', title: 'Gold Backdrop' },
  { id: 3, category: 'Corporate', image: '/images/corporate/corporate4.webp', title: 'Conference Stage' },
  { id: 4, category: 'Private Party', image: '/images/privategatherings/privategatherings3.webp', title: 'Birthday Setup' },
  { id: 5, category: 'Product Launch', image: '/images/product/product3.webp', title: 'Reveal Moment' },
  { id: 6, category: 'Award', image: '/images/awards/award2.webp', title: 'Awards Nights' },
  { id: 7, category: 'Stage Decoration', image: '/images/decor/decor3.webp', title: 'LED Wall' },
  { id: 8, category: 'Corporate', image: '/images/corporate/corporate2.webp', title: 'Innovation' },
  { id: 9, category: 'Private Party', image: '/images/privategatherings/privategatherings2.webp', title: 'Anniversary Table' },
  { id: 10, category: 'Wedding', image: '/images/weddings/wedding2.webp', title: 'Muhurtham Stage' },
  { id: 11, category: 'Product Launch', image: '/images/product/product2.webp', title: 'Brand Wall' },
  { id: 12, category: 'Stage Decoration', image: '/images/decor/decor2.webp', title: 'Floral Arch' },
  { id: 13, category: 'Corporate', image: '/images/corporate/corporate3.webp', title: 'Annual Day' },
  { id: 14, category: 'Award', image: '/images/awards/gallery1.webp', title: 'Pride of Tamil Nadu' },
  { id: 15, category: 'Award', image: '/images/awards/gallery2.webp', title: 'Pride of Tamil Nadu' },
  { id: 16, category: 'Award', image: '/images/awards/gallery3.webp', title: 'Pride of Tamil Nadu' },
  { id: 17, category: 'Award', image: '/images/awards/gallery4.webp', title: 'Pride of Tamil Nadu' },
  { id: 18, category: 'Award', image: '/images/awards/gallery5.webp', title: 'Pride of Tamil Nadu' },
  { id: 19, category: 'Award', image: '/images/awards/gallery6.webp', title: 'Pride of Tamil Nadu' },
  { id: 20, category: 'Award', image: '/images/awards/gallery7.webp', title: 'Pride of Tamil Nadu' },
  { id: 21, category: 'Product Launch', image: '/images/product/product4.webp', title: 'Movie Promotion' },
  { id: 22, category: 'Product Launch', image: '/images/product/product6.webp', title: 'Movie Promotion' },
  { id: 23, category: 'Product Launch', image: '/images/product/product5.webp', title: 'Luna Lithium Battery launch' },
  { id: 24, category: 'Product Launch', image: '/images/product/product7.webp', title: 'Luna Lithium Battery launch' },
]
export const featuredVideos = [
  { id: 'SKCVmGi5Xac', title: 'Event Highlights', type: 'video' },
  { id: 'N06p0ioLvfA', title: 'Mimicry', type: 'video' },
]

export const featuredShorts = [
  { id: 'svnGKYsivvg', title: 'Awards' },
  { id: '7ezui3NKLVE', title: 'Moments' },
  { id: 'gckWWTLs_Ek', title: 'Highlights' },
]

export const testimonials = [
  {
    quote:
      "We handed over one brief and AS Elite Gatherings ran with it — the stage looked better than the mood board. Every guest asked who did the decor.",
    name: 'Corporate Client',
    role: 'Annual Day, Marthandam',
  },
  {
    quote:
      'Our muhurtham and reception felt like two different worlds, both exactly what we wanted, and neither felt rushed. That coordination is rare.',
    name: 'Wedding Client',
    role: 'Wedding, Marthandam',
  },
  {
    quote:
      'The product reveal landed exactly on cue — lighting, sound, timing. That precision is what we were paying for.',
    name: 'Brand Manager',
    role: 'Product Launch',
  },
]

export const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/videos', label: 'Videos' },
  { to: '/contact', label: 'Contact' },
]
